import { Stack, styled } from '@mui/material'
import { Currency } from 'api/v1/market'
import { NoData } from 'components/NoData'
import { memo } from 'react'
import { TokenItem } from './TokenItem'

const Wrap = styled(Stack)`
  gap: 8px;
  position: relative;
  width: 100%;
`

const ListWrap = styled('div')`
  max-height: 200px;
  padding: 8px 0;
  overflow-y: auto;
`

export const FaucetTokenSelection = memo<{
  tokenList: Currency[]
  selectedToken: Currency
  onChangeToken: (token?: Currency) => void
}>(({ tokenList, onChangeToken, selectedToken }) => {
  return (
    <Wrap>
      {tokenList?.length ? (
        <ListWrap>
          {tokenList?.map((item) => (
            <TokenItem
              key={item.id}
              item={item}
              active={item.name === selectedToken?.name}
              onChangeToken={onChangeToken}
            />
          ))}
        </ListWrap>
      ) : (
        <NoData height="160px" />
      )}
    </Wrap>
  )
})
